"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceFileToJSON = exports.ReferenceFileFromJSONTyped = exports.ReferenceFileFromJSON = exports.instanceOfReferenceFile = void 0;
var runtime_1 = require("../runtime");
var Status_1 = require("./Status");
/**
 * Check if a given object implements the ReferenceFile interface.
 */
function instanceOfReferenceFile(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
exports.instanceOfReferenceFile = instanceOfReferenceFile;
function ReferenceFileFromJSON(json) {
    return ReferenceFileFromJSONTyped(json, false);
}
exports.ReferenceFileFromJSON = ReferenceFileFromJSON;
function ReferenceFileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, Status_1.StatusFromJSON)(json['status']),
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
    };
}
exports.ReferenceFileFromJSONTyped = ReferenceFileFromJSONTyped;
function ReferenceFileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'status': (0, Status_1.StatusToJSON)(value.status),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
exports.ReferenceFileToJSON = ReferenceFileToJSON;
